/**
 * @module FieldControls
 */
import { CircularProgress, createStyles, FormHelperText, InputLabel, makeStyles, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import { renderHtml } from '@sensenet/editor-react';
import React, { lazy, Suspense } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
const Editor = /*#__PURE__*/lazy(() => import('../editor-wrapper'));
const useStyles = makeStyles(() => createStyles({
  richTextEditor: {}
}));

const getFieldValue = rawValue => {
  let value;

  if (rawValue === undefined || rawValue === null) {
    return undefined;
  }

  try {
    value = JSON.parse(rawValue);
  } catch (_) {
    return rawValue;
  }

  try {
    return value.editor ? JSON.parse(value.editor) : value.text;
  } catch (_) {
    return value.text;
  }
};
/**
 * Field control that represents a LongText field. Available values will be populated from the FieldSettings.
 */


export const RichTextEditor = props => {
  var _props$localization, _props$localization2;

  const localization = deepMerge(defaultLocalization.richTextEditor, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.richTextEditor);
  const initialState = getFieldValue(props.fieldValue) || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '';
  const classes = useStyles(props);

  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement("div", {
        className: classes.richTextEditor
      }, /*#__PURE__*/React.createElement(InputLabel, {
        shrink: true,
        htmlFor: props.settings.Name,
        required: props.settings.Compulsory
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement(CircularProgress, null), /*#__PURE__*/React.createElement("div", null, localization.loading))
      }, /*#__PURE__*/React.createElement(Editor, {
        content: initialState,
        autofocus: props.autoFocus,
        placeholder: props.settings.DisplayName,
        readOnly: props.settings.ReadOnly,
        localization: (_props$localization2 = props.localization) === null || _props$localization2 === void 0 ? void 0 : _props$localization2.richTextEditor,
        onChange: _ref => {
          var _props$fieldOnChange;

          let {
            editor
          } = _ref;
          (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, {
            text: editor.getHTML(),
            editor: JSON.stringify(editor.getJSON())
          });
        }
      })), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));

    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), initialState ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: typeof initialState === 'string' ? initialState : renderHtml(initialState)
        }
      }) : /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, localization.noValue));
  }
};
//# sourceMappingURL=rich-text-editor.js.map